import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import * as api from "./api.js";

const Ctx = createContext(null);
export const useAuth = () => useContext(Ctx);

/* admin وحده «مدير» في الواجهة - يطابق is_admin() في القاعدة.
   البقية أعضاء؛ صلاحياتهم من member_access (يمنحها المدير). */
const RMAP = { admin: "manager" };

export function AuthProvider({ children }) {
  const [profile, setProfile] = useState(null);
  const [members, setMembers] = useState([]);
  const [ready, setReady] = useState(false);
  const [viewAsId, setViewAsId] = useState(null);
  const [previewPubs, setPreviewPubs] = useState([]);
  const [myGrants, setMyGrants] = useState([]);

  const load = useCallback(async () => {
    try {
      const p = await api.getProfile();
      setProfile(p);
      if (p && p.role === "admin") {
        try { setMembers(await api.listMembers()); } catch {}
      } else if (p) {
        try { const g = await api.listAccess(p.id); setMyGrants(g); if (typeof window !== "undefined") window.__tpmsGrants = g; } catch {}
      }
    } catch (e) { console.error(e); }
    finally { setReady(true); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const isManagerReal = !!(profile && profile.role === "admin");
  const previewing = !!(viewAsId && isManagerReal);
  const role = previewing ? "subuser" : (RMAP[profile?.role] || "subuser");
  // العضو «يعدّل» في الواجهة إن كان عنده منح تعديل واحد على الأقلّ؛ RLS يفرض التفاصيل لكلّ سجلّ
  const canEditAny = myGrants.some((g) => g.can_edit);
  const readOnly = previewing ? true : (role !== "manager" && !canEditAny);
  if (typeof window !== "undefined") { try {
    const _uid = (me && me.id) || (profile && profile.id) || "";
    if (_uid) window.__tpmsUid = _uid;
    window.__tpmsIsAdmin = (profile?.role === "admin") && !previewing;
    window.__tpmsOrg = profile?.org_id || window.__tpmsOrg || null;
  } catch {} }
  const me = profile ? {
    id: previewing ? viewAsId : profile.id,
    fullName: profile.fullName, orgName: profile.orgName,
    assignedPubs: previewing ? previewPubs : "all",
  } : null;

  const setViewAs = async (id) => {
    if (!id) { setViewAsId(null); setPreviewPubs([]); return; }
    try { const pubs = await api.assignedPublisherIds(id); setPreviewPubs(pubs); setViewAsId(id); }
    catch (e) { console.error(e); }
  };

  const value = {
    me, role, realRole: profile?.role || null, readOnly,
    isManager: isManagerReal, previewing, viewAsId,
    grants: myGrants,
    orgName: profile?.orgName || "",
    users: members.map((m) => ({ id: m.id, fullName: m.full_name || m.email, username: m.email, role: RMAP[m.role] || "subuser", status: m.status, assignedPubs: [], assignedBooks: "all" })),
    setAssignment: () => {},
    setViewAs,
    signOut: async () => { await api.signOut(); location.reload(); },
    refresh: load,
  };
  if (!ready) return null;
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}
